import { API } from './App';

// Upload progress measures bytes sent. The server then extracts and indexes text
// before returning 201, so that wait has its own visible phase.
export function uploadDocument({ planId, token, file, scope, parentId = 'root', onProgress }) {
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open('POST', `${API}/api/plans/${planId}/documents`);
    request.setRequestHeader('Authorization', `Bearer ${token}`);
    request.upload.onprogress = event => {
      if (event.lengthComputable) onProgress?.({ phase: 'uploading', percent: Math.min(99, Math.round(event.loaded / event.total * 100)) });
    };
    request.upload.onload = () => onProgress?.({ phase: 'processing', percent: 100 });
    request.onerror = () => reject(new Error('Network error while uploading document'));
    request.onload = () => {
      let result;
      try { result = JSON.parse(request.responseText); }
      catch { return reject(new Error(`Document upload failed (HTTP ${request.status})`)); }
      if (request.status < 200 || request.status >= 300) return reject(new Error(result.error || `Document upload failed (HTTP ${request.status})`));
      resolve(result);
    };
    const body = new FormData();
    body.append('file', file);
    body.append('scope', scope);
    if (scope === 'chat') body.append('parentId', parentId);
    onProgress?.({ phase: 'uploading', percent: 0 });
    request.send(body);
  });
}
